import * as React from 'react';
import { ArticleParagraph1, ILabelProps, Label } from '@cian/ui-kit';

import * as styles from './styles.css';
import { IInformerBanner } from '../../../types/informerBanner';

export const DesktopBannerLayout: React.FC<IInformerBanner['bannerData']> = ({ description, desktopData }) => {
  return (
    <div className={styles['banner']}>
      <div className={styles['title']}>
        {desktopData?.labelData && (
          <Label
            background={desktopData.labelData.labelBackground as ILabelProps['background']}
            color={desktopData.labelData.labelColor as ILabelProps['color']}
          >
            {desktopData.labelData.labelText}
          </Label>
        )}

        <div className={styles['text']}>
          <ArticleParagraph1>{description}</ArticleParagraph1>
        </div>
      </div>

      <div className={styles['icon']}>
        <img src={desktopData.iconUrl} />
      </div>
    </div>
  );
};
